
import Enumerable from "linq";
import { Component, Mixins } from "vue-property-decorator";
import { FilterableMasterSelectableMixin } from "../../../system/selectors/mixins";
import { DomainRegistry } from "../../../../domain";
import { ProjectTeam } from "../../../../domain/projectTeam";

@Component({
})
export default class ProjectTeamSelectableMixin extends Mixins(FilterableMasterSelectableMixin) {
  values: ProjectTeam[];

  created() {
    const repository = DomainRegistry.projectTeam.getProjectTeamRepository();
    repository.getAllEntities()
      .then(teams => this.values = Enumerable.from(teams).where(t => !t.isDeleted).toArray())
      .catch(e => {
        this.$error(
          "プロジェクトチーム情報取得失敗",
          "プロジェクトチーム情報を取得できませんでした。",
          e,
        );
      });
  }
}
